import React from 'react';
import ReactDOM from 'react-dom';
import { RegulatorCentralWidget } from './widgets/RegulatorCentralWidget';
import { SustainabilityWidget } from './widgets/SustainabilityWidget';
import { ReportCsamWidget } from './widgets/ReportCsamWidget';
import '@amzn/katal-components/styles.css';
import {
  APP_CONTAINER_BASE_URL,
  CSAM_CONTAINER,
  DSA_POC_CONTAINER,
  PAYMENT_SERVICES_COMPLAINT_CONTAINER,
  REGULATOR_CENTRAL_CONTAINER,
  SUSTAINABILITY_CONTAINER,
} from './constants/GlobalConstants';
import { PaymentServicesComplaintWidget } from './widgets/PaymentServicesComplaintWidget';
import { DSAArticle11PocWidget } from './widgets/DSAArticle11WidgetPoc';
import { SPIMWidget } from './widgets/SPIMWidget';
import { Provider } from 'react-redux';
import { store } from './state/store';
import { getPathname } from './utilities/HelperUtil';

const pathname = getPathname();

//Rendering for CPR Application.
if (pathname.includes(APP_CONTAINER_BASE_URL.SPIM)) {
  ReactDOM.render(
    <Provider store={store}>
      <SPIMWidget />
    </Provider>,
    document.getElementById(REGULATOR_CENTRAL_CONTAINER),
  );
} else if (document.getElementById(REGULATOR_CENTRAL_CONTAINER)) {
  ReactDOM.render(
    <RegulatorCentralWidget />,
    document.getElementById(REGULATOR_CENTRAL_CONTAINER),
  );
} else if (document.getElementById(SUSTAINABILITY_CONTAINER)) {
  ReactDOM.render(
    <SustainabilityWidget />,
    document.getElementById(SUSTAINABILITY_CONTAINER),
  );
} else if (document.getElementById(CSAM_CONTAINER)) {
  ReactDOM.render(
    <ReportCsamWidget />,
    document.getElementById(CSAM_CONTAINER),
  );
} else if (document.getElementById(PAYMENT_SERVICES_COMPLAINT_CONTAINER)) {
  ReactDOM.render(
    <PaymentServicesComplaintWidget />,
    document.getElementById(PAYMENT_SERVICES_COMPLAINT_CONTAINER),
  );
} else if (document.getElementById(DSA_POC_CONTAINER)) {
  ReactDOM.render(
    <DSAArticle11PocWidget />,
    document.getElementById(DSA_POC_CONTAINER),
  );
}
